import { configureStore } from '@reduxjs/toolkit';
import recipeReducer from './recipe/recipeSlice';
import navReducer from './navigation/navSlice';
import themeReducer from './theme/themeSlice';
import searchFilterReducer from './searchFilter/searchFilterSlice';

export const store = configureStore({
  reducer: {
    recipe: recipeReducer,
    theme: themeReducer,
    searchFilter: searchFilterReducer,
    navs : navReducer
  },
});
